import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  BarChart3,
  Lightbulb,
  Settings,
  Building2,
  Users,
  RefreshCw,
  Link,
  Tags,
  Grid3X3,
  Filter,
  MousePointer2,
  Trophy,
  Route,
  Target,
  HelpCircle,
  Bell,
  FileText,
  TrendingUp,
  PieChart,
  Zap,
  Award,
  Workflow,
} from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'ダッシュボード' },
  { to: '/analysis', icon: BarChart3, label: 'データ分析' },
  { to: '/cross-analysis', icon: Grid3X3, label: 'クロス分析' },
  { to: '/funnel-analysis', icon: Filter, label: 'ファネル分析' },
  { to: '/url-click-analysis', icon: MousePointer2, label: 'URLクリック分析' },
  { to: '/scoring', icon: Trophy, label: '行動スコア' },
  { to: '/inflow-analysis', icon: Route, label: '流入経路分析' },
  { to: '/conversion', icon: Target, label: 'コンバージョン' },
  { to: '/ai-analysis', icon: Lightbulb, label: 'AI分析' },
  { to: '/notifications', icon: Bell, label: '通知' },
  { to: '/reports', icon: FileText, label: 'レポート' },
  { to: '/prediction', icon: TrendingUp, label: '予測分析' },
  { to: '/segment-analysis', icon: PieChart, label: 'セグメント分析' },
  { to: '/insights', icon: Zap, label: 'AIインサイト' },
  { to: '/success-cases', icon: Award, label: '成功事例' },
  { to: '/help', icon: HelpCircle, label: '使い方ガイド' },
];

const adminItems = [
  { to: '/admin/companies', icon: Building2, label: '法人管理' },
  { to: '/admin/users', icon: Users, label: 'ユーザー管理' },
  { to: '/admin/scraping', icon: RefreshCw, label: 'スクレイピング' },
  { to: '/admin/automation', icon: Workflow, label: '自動化' },
  { to: '/labels', icon: Tags, label: 'ラベル管理' },
];

export default function Sidebar() {
  const isSuperAdmin = useAuthStore((state) => state.isSuperAdmin);

  return (
    <aside className="w-64 bg-white border-r border-gray-200 h-full overflow-y-auto">
      <nav className="p-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-white'
                  : 'text-gray-600 hover:bg-gray-100'
              )
            }
          >
            <item.icon className="w-5 h-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}

        {/* 法人管理者用メニュー */}
        {!isSuperAdmin() && (
          <>
            <div className="pt-4 pb-2">
              <span className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                法人設定
              </span>
            </div>
            <NavLink
              to="/my-company"
              className={({ isActive }) =>
                cn(
                  'flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                )
              }
            >
              <Link className="w-5 h-5" />
              <span>UTAGE連携</span>
            </NavLink>
            <NavLink
              to="/labels"
              className={({ isActive }) =>
                cn(
                  'flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                )
              }
            >
              <Tags className="w-5 h-5" />
              <span>ラベル管理</span>
            </NavLink>
          </>
        )}

        {/* スーパー管理者用メニュー */}
        {isSuperAdmin() && (
          <>
            <div className="pt-4 pb-2">
              <span className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                管理者メニュー
              </span>
            </div>
            {adminItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-gray-600 hover:bg-gray-100'
                  )
                }
              >
                <item.icon className="w-5 h-5" />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </>
        )}

        {/* アカウント設定 */}
        <div className="pt-4 pb-2">
          <span className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
            アカウント
          </span>
        </div>
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            cn(
              'flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
              isActive
                ? 'bg-primary text-white'
                : 'text-gray-600 hover:bg-gray-100'
            )
          }
        >
          <Settings className="w-5 h-5" />
          <span>アカウント設定</span>
        </NavLink>
      </nav>
    </aside>
  );
}
